const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

// The issue date is stored as "YYYY", "YYYY-MM", "YYYY-MM-DD", or free
// text like "unknown". Format the structured forms for display
// ("1967-04-06" → "April 6, 1967"); anything else passes through as-is.
export function formatIssueDate(value) {
  if (!value) return value;
  const match = /^(\d{4})(?:-(\d{1,2}))?(?:-(\d{1,2}))?$/.exec(value.trim());
  if (!match) return value;
  const [, year, month, day] = match;
  if (!month) return year;
  const monthName = MONTHS[Number(month) - 1];
  if (!monthName) return value;
  if (!day) return `${monthName} ${year}`;
  return `${monthName} ${Number(day)}, ${year}`;
}

// Just the year for compact contexts (tiles); free text passes through.
export function issueYear(value) {
  if (!value) return value;
  const match = /^(\d{4})/.exec(value.trim());
  return match ? match[1] : value;
}
